module.exports = __webpack_public_path__ + "img/header.b9ed6e9d.png";